import { render, staticRenderFns } from "./Messages.component.html?vue&type=template&id=c5148b3a&scoped=true&"
import script from "./Messages.component.ts?vue&type=script&lang=ts&"
export * from "./Messages.component.ts?vue&type=script&lang=ts&"
import style0 from "./Messages.component.scss?vue&type=style&index=0&id=c5148b3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5148b3a",
  null
  
)

export default component.exports